import AllCollectors from "./AllCollectors";
import Annotations from "./Annotations";
import AverageVisit from "./AverageVisit";
import Collected from "./Collected";
import Highlights from "./Highlights";
import Engagement from "./Engagement";
import NewCollectors from "./NewCollectors";
import ReturnVisits from "./ReturnVisits";
import SiteStatistics from "./SiteStatistics";
import TopProjects from "./TopProjects";
import TopSearches from "./TopSearches";
import Visitors from "./Visitors";
import ShareClicks from "./ShareClicks";
import Citations from "./Citations";
import TextSectionViews from "./TextSectionViews";
import Downloads from "./Downloads";

export default {
  Annotations,
  AllCollectors,
  AverageVisit,
  Collected,
  Highlights,
  Engagement,
  NewCollectors,
  ReturnVisits,
  SiteStatistics,
  TopProjects,
  TopSearches,
  Visitors,
  ShareClicks,
  Citations,
  TextSectionViews,
  Downloads
};
